// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.5 14H4C2.9 14 2 13.1 2 12V4C2 2.9 2.9 2 4 2H6.5',
  'M11 11L14 8L11 5M14 8H6',
];
